import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum CallTypeEnum {
    Incoming = 1,
    Outgoing = 2,
    Missed = 3
}

export enum CallTypeNameEnum {
    "Incoming" = CallTypeEnum.Incoming,
    "Outgoing" = CallTypeEnum.Outgoing,
    "Missed" = CallTypeEnum.Missed
}

export class CallTypeEnumClass extends EnumWithDescription<CallTypeEnum> {
    public readonly enum = CallTypeEnum;
    public readonly enumName: string = "CallType";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<CallTypeEnum>> = new Map([
        [
            "Incoming",
            {
                value: CallTypeEnum.Incoming,
                name: "Incoming"
            }
        ],
        [
            "Outgoing",
            {
                value: CallTypeEnum.Outgoing,
                name: "Outgoing"
            }
        ],
        [
            "Missed",
            {
                value: CallTypeEnum.Missed,
                name: "Missed"
            }
        ]
    ]);
}

export const CallType = new CallTypeEnumClass();
